export default {
  queryParam: "modalView",
  signin: "signin",
  signup: "signup",
  verify: "verify",
  authorize: "authenticate"
};
